export const SPACE_MANAGER_ANALYTICS_SOURCE = 'spaceManager';
